import React from "react";
import { Helmet } from "react-helmet";
import "./FAQ.css";

const faqData = [
  {
    question: "Do you work with all medical specialties?",
    answer:
      "Yes. We support a wide range of medical specialties and customize our billing workflows based on each provider’s requirements.",
  },
  {
    question: "Are your services HIPAA compliant?",
    answer:
      "Yes. We follow strict HIPAA-compliant processes, including secure data handling, encryption, and controlled access.",
  },
  {
    question: "How do you charge for your services?",
    answer:
      "We offer flexible pricing models, including percentage-based collections or fixed monthly plans.",
  },
  {
    question: "How soon can we get started?",
    answer:
      "Onboarding typically takes 3–7 business days, depending on system access and credentialing.",
  },
  {
    question: "Do you work with all EMR/EHR systems?",
    answer:
      "Yes. We work with all major EMR/EHR and billing platforms used in the US healthcare industry.",
  },
  {
    question: "How do you handle claim denials?",
    answer:
      "Our team analyzes denial root causes, submits appeals when needed, and implements preventive measures to reduce future denials.",
  },
  {
    question: "Will I receive regular billing reports?",
    answer:
      "Yes. We provide weekly and monthly performance reports covering claims status, A/R aging, and revenue trends.",
  },
  {
    question: "Will I have a dedicated account manager?",
    answer:
      "Yes. Each client is assigned a dedicated account manager as a single point of contact.",
  },
];

const FAQ = () => (
  <>
    <Helmet>
      <title>FAQ | OptiBill Analytics - Medical Billing Questions</title>
      <meta name="description" content="Find answers to frequently asked questions about our medical billing and RCM services: HIPAA compliance, pricing, specialties, claim denials, reporting, and more." />
      <meta name="keywords" content="medical billing FAQ, RCM questions, HIPAA compliance, billing service pricing, claim denial management, EMR systems, medical specialties" />
      <meta property="og:title" content="FAQ | OptiBill Analytics" />
      <meta property="og:description" content="Answers to common questions about our medical billing and revenue cycle management services." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.optibillanalytics.com/faq" />
      <link rel="canonical" href="https://www.optibillanalytics.com/faq" />
    </Helmet>
    <section className="page-shell" aria-labelledby="faq-heading">
    <div className="page-container">
    <div className="page-header">
      <h2 id="faq-heading" className="page-title">
        Frequently Asked Questions
      </h2>
      <p className="page-subtitle">
        Answers to common questions about our medical billing services
      </p>
    </div>

    <div className="accordion faq-accordion" id="faqAccordion">
      {faqData.map((item, index) => (
        <div className="accordion-item mb-3 faq-item" key={index}>
          <h2 className="accordion-header" id={`heading${index}`}>
            <button
              className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#faq${index}`}
              aria-expanded={index === 0}
              aria-controls={`faq${index}`}
              style={{ fontWeight: "600" }}
            >
              {item.question}
            </button>
          </h2>
          <div
            id={`faq${index}`}
            className={`accordion-collapse collapse ${
              index === 0 ? "show" : ""
            }`}
            aria-labelledby={`heading${index}`}
            data-bs-parent="#faqAccordion"
          >
            <div className="accordion-body text-muted">{item.answer}</div>
          </div>
        </div>
      ))}
    </div>
    </div>
  </section>
  </>
);

export default FAQ;